import {
  ConstellationFilterInput,
  ConstellationType,
  ConstellationTypeID
} from '@apeiron/star'
import { styled } from '@mui/material'
import {
  ChipToggleButton,
  ChipToggleButtonGroup
} from '@src/components/share/filter/ChipToggle'
import useFetchStarFilterJson from '@src/hooks/json/useFetchStarFilterJson'
import { FC, useCallback, useEffect, useState } from 'react'

const ChipGroup = styled(ChipToggleButtonGroup)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const ChipButton = styled(ChipToggleButton)`
  padding: 4px 24px;
  font-size: 14px;
`

const ConstellationSizeFilter: FC<Props> = (props: Props) => {
  const { className, filterInput, onFilterChange } = props

  const { data: filterData } = useFetchStarFilterJson()

  const [constellationTypes, setConstellationTypes] = useState<
    ConstellationType[]
  >([])

  const [selected, setSelected] = useState<ConstellationTypeID[]>(
    filterInput.types
  )

  const handleOnChange = useCallback(
    (_: any, types: ConstellationTypeID[]) => {
      setSelected(types)
      if (onFilterChange) {
        onFilterChange({
          ...filterInput,
          types
        })
      }
    },
    [filterInput, onFilterChange]
  )

  useEffect(() => {
    setConstellationTypes(filterData?.starFilterConstellations.types || [])
  }, [filterData])

  return (
    <ChipGroup className={className} value={selected} onChange={handleOnChange}>
      {constellationTypes.map((constellationType: ConstellationType) => (
        <ChipButton key={constellationType.id} value={constellationType.id}>
          {constellationType.name}
        </ChipButton>
      ))}
    </ChipGroup>
  )
}

export type Props = {
  className?: string
  filterInput: ConstellationFilterInput
  onFilterChange?: (input: ConstellationFilterInput) => void
}

export default ConstellationSizeFilter
